import { dashboardService } from "@/api/services/dashboardService";
import { DashboardApiTrendWidget } from "../dashboardLeafWidgets";

type Data = Record<string, any>;

/** 新增会员用户分析，沿用 Vue 接口的月度数组并支持日期切换。 */
export default function AddMemberCustomerAnalysis() {
    return (
        <DashboardApiTrendWidget<Data>
            title="会员用户新增分析"
            load={value => dashboardService.getAddMemberCustomerAnalysis(value as never)}
            series={[
                { label: "新增基础会员", key: "addBaseMemberNums" },
                { label: "新增高级会员", key: "addSeniorMemberNums" },
                { label: "新增企业会员", key: "addEnterpriseGradeMemberNums" }
            ]}
        />
    );
}
